import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Tooltip } from '@mui/material';
import { memo, useMemo } from 'react';
import { getRfBatteryIcon } from './utils/rf-icons';
import { getStrForBatteryVoltage } from 'console/tabs/legacy/rf/rf-utils';
export const RFBatteryIndicator = memo(function RFBatteryIndicator({ bat, bat_v, type, }) {
    const str = useMemo(() => getStrForBatteryVoltage(bat, bat_v, type), [type, bat, bat_v]);
    const level = useMemo(() => bat != null
        ? Math.trunc(bat / 4)
        : bat_v != null
            ? Math.min(~~(Math.min(Math.max(bat_v - 2, 0), 1) * 4), 3)
            : 0, [bat, bat_v]);
    return (_jsx(Tooltip, { title: str, children: _jsx(Box, { display: "flex", alignItems: "center", children: getRfBatteryIcon(level) }) }));
});
